// @mui
import { makeStyles } from '@mui/styles';


export const style = (theme) => ({
  input: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    
    '& .PhoneInput': {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
    },
    
    '& .PhoneInputCountry': {
      marginRight: theme.spacing(1),
      display: 'flex',
      alignItems: 'center',
    },
    
    '& .PhoneInputCountryIcon': {
      width: '24px',
      height: '18px',
      border: 'none',
      boxShadow: 'none',
      marginRight: theme.spacing(0.5),
    },
    
    '& .PhoneInputCountrySelect': {
      marginRight: theme.spacing(1),
      padding: 0,
      border: 'none',
      background: 'transparent',
      cursor: 'pointer',
      fontSize: 'inherit',
      fontFamily: 'inherit',
    },
    
    '& .PhoneInputCountrySelectArrow': {
      opacity: 0.5,
      marginLeft: theme.spacing(0.5),
    },
    
    '& .PhoneInputInput': {
      flex: 1,
      border: 'none',
      outline: 'none',
      background: 'transparent',
      padding: 0,
      fontSize: 'inherit',
      fontFamily: 'inherit',
      color: 'inherit',
    },
    
    '& .MuiButton-root': {
      border: 0,
    },
    '& .MuiButton-root:hover': {
      background: 'transparent',
    },
  },

  dropdown: {
    '& .dial-code': {
      marginLeft: theme.spacing(),
    },
  },

  button: {
    boxShadow: 'none',
    background: 'transparent',

    '&:hover': {
      backgroundColor: 'transparent',
      boxShadow: 'none',
    },

    '&:active': {
      boxShadow: 'none',
    },
  },
});

export const useStyle = makeStyles(style);
